import styled from "styled-components";

import Avatar from "@mui/material/Avatar";

export const CastImg = styled(Avatar)`
    height: 200px !important;
    width: 200px !important;
`;
